<template>
  <div class="mt-3">
    <h2>Kategoriebaum</h2>
    <div class="row mt-2">
      <div class="col-md">
        <ul class="cat-tree" style="margin-left:20px;">
          <CatTreeItem @selected="passSelected" v-for="cat in root" :key="cat.map_id" :item="cat"/>
        </ul>
      </div>
      <div class="col-md">
        <CategoryInfo :cat="category"/>
      </div>
    </div>
  </div>
</template>

<script>
import articles from '@/modules/articles.js'
import CatTreeItem from '@/components/articles/CatTreeItem.vue'
import CategoryInfo from '@/components/articles/CategoryInfo.vue'

export default {
  name: 'CategoryTree',
  components: {
    CatTreeItem,
    CategoryInfo
  },
  data() {
    return {
      category: {},
      root: []
    }
  },
  created: function() {
    this.updateTree();
  },
  methods: {
    passSelected: function(cat) {
      this.category = cat.cat;
    },
    updateTree: function() {
      var self = this;
      articles.cattree().then(function (data) {
        self.root = data;
      });
    }
  }
}
</script>

<style>
.cat-tree {
  list-style: none;
  padding-left: 10px;
}
.cat-tree-item {
}
.cat-tree-item span {
  display: block;
  width: 200px;
  padding: 4px 10px;
  font-weight: bold;
  font-size: 16px;
  background-color: #eee;
  border-bottom: 1px solid #ccc;
}
.cat-tree-item span:hover {
  cursor: pointer;
  background-color: #ccc;
}

</style>
